// src/components/notifications/notificationMeta.js
// Группа, цвет, иконка и время уведомления для списка и деталей
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { SECTION_ACCENTS } from '../../styles/tokens';
import { EVENT_TYPE_GROUPS, GROUP_COLORS, GROUP_ICONS } from '../events/eventMeta';

const NEUTRAL_COLOR = '#a1a1aa';

// Группа уведомления: у события — по типу, у сводки — по первому типу в ней
export function notificationGroup(item) {
  const type = item.kind === 'event' ? item.event_type : Object.keys(item.payload?.counts || {})[0];
  return EVENT_TYPE_GROUPS[type] || null;
}

export function notificationLook(item) {
  // Сводка после закрытия смены — цвет раздела «Выручка»
  if (item.kind === 'shift_summary') return { color: SECTION_ACCENTS['/metrics'].accent, Icon: PointOfSaleIcon };
  // Оповещение админу о сбое (data_service/services/alerts.py); «Восстановлено: …» — зелёным
  if (item.kind === 'alert') {
    return item.title?.startsWith('Восстановлено')
      ? { color: '#66bb6a', Icon: ReportProblemOutlinedIcon }
      : { color: '#ef5350', Icon: ReportProblemOutlinedIcon };
  }
  // Отзыв пользователя админу (data_service/services/feedback.py)
  if (item.kind === 'feedback') return { color: '#64b5f6', Icon: ChatBubbleOutlineIcon };
  // Новые минусы на складе (data_service/notifications/stock.py) — цвет «Себестоимости», где вкладка «Склад»
  if (item.kind === 'stock') return { color: SECTION_ACCENTS['/cost'].accent, Icon: Inventory2OutlinedIcon };
  const group = notificationGroup(item);
  return {
    color: GROUP_COLORS[group] || NEUTRAL_COLOR,
    Icon: GROUP_ICONS[group] || NotificationsIcon,
  };
}

// API отдаёт created_at/read_at в UTC с «Z» («2026-10-23T18:30:00Z»)
export function parseServerTime(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

// «Только что», «12 мин назад», «сегодня, 21:14», «вчера, 21:14», «21.10, 21:14»
export function formatNotificationTime(value, now = new Date()) {
  const date = parseServerTime(value);
  if (!date) return '';
  const minutes = Math.floor((now - date) / 60000);
  if (minutes < 1) return 'только что';
  if (minutes < 60) return `${minutes} мин назад`;
  const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  if (sameDay(date, now)) return `сегодня, ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(date, yesterday)) return `вчера, ${time}`;
  return `${date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })}, ${time}`;
}
